// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flag-post svg {
    width: 18px;
    height: 18px;
    margin-bottom: -4px;
}
.flag-post.are-you-sure {
    max-width: 600px;
}
.flag-post.are-you-sure .flag-post__explanation {
    text-align: left;
}
.flag-post.flag-post__flagged, .flag-post.flag-post__rejected {
    color: var(--danger-color-light) !important;
}
.flag-post.flag-post__approved {
    color: var(--success-color-light) !important;
}
.flag-post__choose .flag-post__choose__explanation {
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/Post/PostDotsMenu/FlagPost/FlagPost.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,4CAA4C;AAChD;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".flag-post svg {\n    width: 18px;\n    height: 18px;\n    margin-bottom: -4px;\n}\n.flag-post.are-you-sure {\n    max-width: 600px;\n}\n.flag-post.are-you-sure .flag-post__explanation {\n    text-align: left;\n}\n.flag-post.flag-post__flagged, .flag-post.flag-post__rejected {\n    color: var(--danger-color-light) !important;\n}\n.flag-post.flag-post__approved {\n    color: var(--success-color-light) !important;\n}\n.flag-post__choose .flag-post__choose__explanation {\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
